import { useEffect, useRef } from "react";
import clockImage from "./assets/clock.png";
import { useOnScreen } from "../../hooks";
import IconTint from "react-icon-tint";
import { isMobile } from "react-device-detect";
import DSTypography from "../system-design/Typography/DSTypography";
import DSBox from "../system-design/DSBox";
import DSAvatar from "../system-design/DSAvatar";
import { KLYDO_BLACK } from "../../consts/colors";
import { Klydo } from "../../context/klydo/KlydoTypes";
import { KlydoGiftProps } from "../../api/gift";
export type GiftViewProps = {
  klydo: Klydo;
  gift: KlydoGiftProps;
  isToggled?: boolean;
};
const secondsForMin = 3600;
const secondsForHour = 43200;
const GiftView = ({
  klydo,
  gift,
  isToggled = false,
}: GiftViewProps): JSX.Element => {
  const ref = useRef<HTMLDivElement>(null);
  const handMin = useRef<HTMLDivElement>(null);
  const handHour = useRef<HTMLDivElement>(null);
  const handHourS = useRef<HTMLDivElement>(null);
  const handMinS = useRef<HTMLDivElement>(null);
  const isVisible = useOnScreen(ref);
  const ii = useRef<NodeJS.Timeout>();
  const loopUrl = klydo?.klydoAnimation?.l || klydo?.loopUrl;
  const handsColor = klydo?.theme?.handsColor;
  const backgroundColor = klydo?.theme?.backgroundColor;
  const pendulumColor = klydo?.theme?.pendulumColor;
  const pendulumRodColor = klydo?.theme?.pendulumRodColor;
  const senderName = gift?.senderName;
  const senderImageUrl = gift?.senderImageUrl;
  const greetingContent = gift?.greetingContent;
  const date = gift?.date;
  const handleLoopUrl = () => {
    if (loopUrl) {
      return (
        <video
          muted={true}
          src={loopUrl}
          style={{
            width: "100%",
            height: "100%",
            borderRadius: "50%",
            objectFit: "cover",
          }}
          autoPlay
          loop
          playsInline
        />
      );
    }
    return null;
  };
  useEffect(() => {
    const updHands = () => {
      const dt = new Date();
      const seconds = dt.getMinutes() * 60 + dt.getSeconds();
      const dgmin = (seconds / secondsForMin) * 360;
      if (handMin.current) {
        handMin.current.style.transform = `rotate(${dgmin}deg)`;
      }
      if (handMinS.current) {
        handMinS.current.style.transform = `rotate(${dgmin}deg)`;
      }
      const hours = (dt.getHours() % 12) * 3600 + seconds;
      const dgh = (hours / secondsForHour) * 360;
      if (handHour.current) {
        handHour.current.style.transform = `rotate(${dgh}deg)`;
      }
      if (handHourS.current) {
        handHourS.current.style.transform = `rotate(${dgh}deg)`;
      }
    };
    ii.current = setInterval(updHands, 2000);
    updHands();
    return () => clearInterval(ii.current);
  }, [isVisible]);
  return (
    <div
      ref={ref}
      style={{ position: "absolute", width: "100%", height: "100%" }}
    >
      <div
        style={{
          position: "absolute",
          top: "5%",
          left: "5%",
          width: "90%",
          height: "90%",
          backgroundColor: backgroundColor,
        }}
      />
      <div
        style={{
          left: "35%",
          top: "27%",
          width: "30%",
          height: "60%",
          position: "absolute",
          transformOrigin: "50% 0px",
          animation: "2s ease-in-out 0s infinite normal none running swing-4",
        }}
      >
        <div
          style={{
            position: "absolute",
            left: "48.5%",
            transformOrigin: "50% 0px",
            backgroundColor: pendulumRodColor,
            width: "4%",
            height: "71%",
          }}
        />
        <DSBox
          position={"absolute"}
          borderRadius="50%"
          boxShadow={"rgba(0, 0, 0, 0.55) 0px 2px 3.2px 0px"}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "29%",
            bottom: 0,
            gap: 0.5,
            backgroundColor: pendulumColor,
          }}
        >
          <>
            <IconTint
              src={
                gift?.pendulumLogoUrl ||
                "https://res.cloudinary.com/klydoclock/image/upload/v1727775595/pack_pendulum_covers/hmzb88yhzidkjujf8xbt.png"
              }
              color={backgroundColor}
              maxWidth={50}
              maxHeight={40}
            />
            <DSTypography
              fontFamily={"Gilroy-SemiBold"}
              fontSize={isMobile ? "6.5px" : "8px"}
              color={backgroundColor}
              sx={{ marginTop: -0.7 }}
            >
              {senderName}
            </DSTypography>
          </>
        </DSBox>
      </div>
      <div
        style={{
          width: "80%",
          aspectRatio: "1/1",
          height: "auto",
          top: "5.5%",
          left: "10%",
          position: "absolute",
          overflow: "hidden",
          display: "flex",
          borderRadius: "50%",
          justifyContent: "center",
          backgroundColor: backgroundColor,
        }}
      >
        {isToggled && (
          <div
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              backgroundColor: KLYDO_BLACK,
              borderRadius: "50%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 10,
            }}
          >
            <DSBox
              sx={{
                zIndex: 11,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <DSAvatar
                sx={{
                  width: { xs: 45, md: 60 },
                  height: { xs: 45, md: 60 },
                  backgroundColor: KLYDO_BLACK,
                  position: "absolute",
                  top: 12,
                }}
              >
                <img
                  src={senderImageUrl}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "fill",
                    borderRadius: "50%",
                    backgroundColor: KLYDO_BLACK,
                  }}
                />
              </DSAvatar>
              <DSBox py={3} />
              <DSTypography
                fontFamily={"Gilroy-SemiBold"}
                fontSize={isMobile ? "9px" : "10.5px"}
                maxWidth={isMobile ? "150px" : "180px"}
                sx={{
                  position: "relative",
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                }}
              >
                {greetingContent}
              </DSTypography>
              {date && (
                <DSTypography
                  fontFamily={"Gilroy-SemiBold"}
                  fontSize={isMobile ? "8.5px" : "10px"}
                  sx={{
                    position: "absolute",
                    bottom: 20,
                  }}
                >
                  {new Date(date).toLocaleString("default", {
                    month: "long",
                    day: "numeric",
                    year: "numeric",
                  })}
                </DSTypography>
              )}
            </DSBox>
          </div>
        )}
        <div>{handleLoopUrl()}</div>
      </div>
      <time
        dateTime="2023-06-30T04:48:07.668Z"
        style={{
          padding: "38.5%",
          top: "6.95%",
          position: "absolute",
          left: "11.6%",
        }}
      >
        <div // hour shadow
          ref={handHourS}
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            left: "0.4%",
            top: "1.2%",
            transformOrigin: "center",
            zIndex: 2,
          }}
        >
          <div
            style={{
              position: "absolute",
              borderRadius: "10px",
              width: "4%",
              height: "35%",
              bottom: "46%",
              left: "48%",
              background:
                "radial-gradient(ellipse at center, #000000 0%, #00000000 100%)",
            }}
          />
        </div>
        <div // hour
          ref={handHour}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            transformOrigin: "center",
            zIndex: 3,
          }}
        >
          <div
            style={{
              position: "absolute",
              borderRadius: "10px",
              width: "4%",
              height: "35%",
              bottom: "46%",
              left: "48%",
              backgroundColor: handsColor,
            }}
          />
        </div>
        <div // minute shadow
          ref={handMinS}
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            left: "1.2%",
            top: "1.4%",
            transformOrigin: "center",
            zIndex: 2,
          }}
        >
          <div
            style={{
              position: "absolute",
              borderRadius: "4px",
              width: "3%",
              height: "45%",
              bottom: "45%",
              left: "48.75%",
              background:
                "radial-gradient(ellipse at center, #000000 0%, #00000000 100%)",
            }}
          />
        </div>
        <div // minute
          ref={handMin}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            zIndex: 3,
            transformOrigin: "center",
          }}
        >
          <div
            style={{
              position: "absolute",
              borderRadius: "4px",
              width: "3%",
              height: "45%",
              bottom: "45%",
              left: "48.75%",
              backgroundColor: handsColor,
            }}
          />
        </div>
      </time>
      <img
        loading="lazy"
        src={clockImage}
        alt="Klydo Clock"
        style={{
          top: "-1.5",
          left: 0,
          width: "100%",
          height: "auto",
          position: "absolute",
          zIndex: 1,
        }}
      />
    </div>
  );
};
export default GiftView;
